import type React from "react";

import { HealthReports } from "../components/HealthReports/HealthReports";

export const HealthQuestionnaires: React.FC = () => {
  return (
    <div data-testid="health-questionnaires">
      <HealthReports />
    </div>
  );
};
